import type { PathConfig } from '@react-navigation/native';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/onboarding',
  screens: {
    credentials: '/credentials',
    'personal-information': '/personal-information',
    'contact-information': '/contact-information',
    guidelines: '/guidelines',
    choose: '/choose',
    confirm: '/confirm',
    thanks: '/thanks',
  },
};
